export default {
	title: 'ステーク',
	url: 'stakes',
	no_description: '目標が未定義です',
	context_worse: 'ネガティブ',
	context_best: 'ポジティブ',
	tabs: {
		filters: {
			title: '表示フィルター'
		},
		general: {
			title: '一般'
		},
		export: {
			title: 'エクスポート'
		},
		comments: {
			title: '履歴'
		},
		bot: {
			title: 'AI'
		}
	},
	messages: {
		edit_stake: 'ステークの編集',
		create_stake: '新しいステークを作成'
	},
	onboarding: {
		title: 'ステークの確認',
		description:
			'AIがあなたのテーマの構造的なステークを特定しました。何もしなければ失う、または得る可能性があるものを本当に表しているか確認してください。必要に応じて調整、削除、追加してください。'
	}
};
